@import '../../global/style/custom-properties/components-properties/static-teaser';

:host {
  width: 100%;

  @include cms-components-host-defaults;
}

.target-icon {
  display: flex;
}

.teaser-href:hover .target-name {
  text-decoration: underline;
}

.container-wrapper-inner {
  @include container-wrapper-inner;

  & .teaser-content {
    @include cms-default-grid-container;

    & .teaser-content-inner {
      @include teaser-content-inner;

      & cms-badge {
        @include cms-static-teaser-badge;
      }

      & .scratch svg path {
        @include cms-static-teaser-scratch-svg-path;
      }

      & .teaser-bottom {
        @include cms-static-teaser-bottom;
      }

      & .teaser-bottom svg path {
        @include cms-static-teaser-bottom-svg-path;
      }
    }
  }

  & .all-topics-wrapper {
    padding-top: 1.5rem;
    text-align: center;
  }

  & .all-topics-href {
    border-bottom-width: 2px;
    border-bottom-style: solid;
    color: css-var(theme-text-color);
    text-decoration: none;

    @include label-base-font;

    &:hover {
      border-bottom: none;
    }
  }
}
